import React from 'react';

function Spinner({
    className = 'border-t-4 border-b-4 border-white h-12 w-12'
}) {
    return <div className={`animate-spin rounded-full ${className}`}></div>;
}

export default Spinner;
